import { useEffect, useRef, useState } from "react";

const EVENTS = ["mousemove", "mousedown", "keydown", "touchstart", "scroll", "wheel"];

// HIPAA automatic logoff: fires onTimeout after `minutes` without user activity; `warning` turns on `warnSeconds` before.
export function useIdleLogout({ minutes, onTimeout, warnSeconds = 60, enabled = true }) {
  const last = useRef(Date.now());
  const fired = useRef(false);
  const [warning, setWarning] = useState(false);
  const [secondsLeft, setSecondsLeft] = useState(0);

  useEffect(() => {
    if (!enabled || !minutes) return undefined;
    last.current = Date.now();
    fired.current = false;
    let throttle = 0;
    const bump = () => {
      const now = Date.now();
      if (now - throttle < 1000) return;
      throttle = now;
      last.current = now;
      setWarning(false);
    };
    EVENTS.forEach((e) => window.addEventListener(e, bump, { passive: true }));
    const iv = setInterval(() => {
      const idle = (Date.now() - last.current) / 1000;
      const limit = minutes * 60;
      if (idle >= limit) {
        if (!fired.current) { fired.current = true; onTimeout(); }
        return;
      }
      if (idle >= limit - warnSeconds) { setWarning(true); setSecondsLeft(Math.max(0, Math.ceil(limit - idle))); }
    }, 1000);
    return () => { EVENTS.forEach((e) => window.removeEventListener(e, bump)); clearInterval(iv); };
  }, [minutes, warnSeconds, enabled, onTimeout]);

  const stay = () => { last.current = Date.now(); setWarning(false); };
  return { warning, secondsLeft, stay };
}
